import React from "react";
import ContourImg from "./../../assets/images/contour.png";
import ContourImg2 from "./../../assets/images/contour2.png";
import ContourImg3 from "./../../assets/images/contour3.png";
import ContourMini from "./../../assets/images/contour_mini.png";
import "./contour.css";
const Contour = () => {
  const shopNow = () => {
    window.open(
      'https://a.co/d/1Tnoxt3',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  return (
    <div className="contour">
      <div className="contour_right">
        <div style={{ flex: 1 }} className="contour_content_spacer"></div>

        <div style={{ flex: 3 }}>
          <div className="contour_heading">
            <div className="contour_mini">
              <img src={ContourMini} alt=" " />
            </div>
            <p className="contour_heading">
              Contour <br /> Blender
            </p>
          </div>
          <p className="contour_description">
            Designed to take a cream contour product and using the pointed tip
            of the blender draw lines onto the hollows of your cheekbones,
            jawline and sides of nose. With the curved surface of the blender
            use rolling motions to blend out lines for a sculpted effect.
          </p>
          <button className="primary_btn" onClick={()=> shopNow()}>Shop Now</button>
        </div>
      </div>
      <div className="contour_left">
        <div style={{ flex: 3, padding: 0, margin: 0 }}>
          <img src={ContourImg} alt=" " width="100%" height="100%" />
        </div>
        <div style={{ flex: 1, padding: 0, margin: 0 }}>
          <img
            src={ContourImg2}
            alt=" "
            width="100%"
            height="100%"
            className="contour_desktop"
          />
          <img
            src={ContourImg3}
            alt=" "
            width="100%"
            className="contour_mobile"
          />
        </div>
      </div>
    </div>
  );
};

export default Contour;
